import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-ramadan2022-player-qualified',
  templateUrl: './ramadan2022-player-qualified.component.html',
  styleUrls: ['./ramadan2022-player-qualified.component.scss']
})
export class Ramadan2022PlayerQualifiedComponent implements OnInit {
  activeGame
  games;
  tournaments;
  loadIndicator = false
  participants
  constructor(private router:Router , private activatedRoute:ActivatedRoute , public eventService:EventsService , public globalService:GlobalService) { }

  ngOnInit(): void {

    this.loadIndicator = true
    this.participants = []

    // this.eventService.getParticipants('zfg7538G1OIl', 1).subscribe((res) => {
    //   this.participants = res.participants;
    //   this.loadIndicator = false
    //
    // });
  }
  setActiveGame(code) {
    console.log(code)
    this.activeGame = code;
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: {game: code},
        queryParamsHandling: 'merge'
      });
    this.getGameTournments()
  }
  getGameTournments() {
  }

}
